import { useLocale as useNextIntlLocale } from 'next-intl';
import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';
import type { ComponentProps } from 'react';
import React from 'react';
import type { SupportedLanguage } from '@/app/types';
import { LANGUAGE_CONFIG } from './config';

/**
 * `as-needed` 下默认语言无前缀，首段可能被当成 locale，与 middleware 组合后易出现「补全 locale ↔ 去掉默认前缀」的循环重定向（Playwright: ERR_TOO_MANY_REDIRECTS）。
 * E2E 托管 preview（`E2E_LOCAL_PREVIEW=1`）改为 `always`，强制 `/{locale}/...`，与 `withE2ERouteLocale` 显式前缀一致。
 */
export const routing = defineRouting({
  locales: LANGUAGE_CONFIG.supported,
  defaultLocale: LANGUAGE_CONFIG.default,
  localePrefix: process.env.E2E_LOCAL_PREVIEW === '1' ? 'always' : 'as-needed',
});

// TOFIX: createSharedPathnamesNavigation is deprecated, use createNavigation instead
const navigation = createNavigation(routing);
const LinkPrimitive = navigation.Link;

export const Link = ({ prefetch = false, ...props }: ComponentProps<typeof LinkPrimitive>) => {
  const dataAttr = { 'data-google-interstitial': 'false' } as const;
  return React.createElement(LinkPrimitive, { ...props, prefetch, ...dataAttr });
};

export const { redirect, usePathname, useRouter } = navigation;

// 增加了类型提示的 useLocale
export function useLocale(): SupportedLanguage {
  return useNextIntlLocale() as SupportedLanguage;
}
